import { useModuleBEM } from "@b2bportal/core-themes";
import { Funnel } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

import styles from "./HotelDealsSection.module.scss";

import { TravelDealsCarousel, useTravelDeals } from "@/modules/dealTiles";
import { HtsMediaDealTilePlacement } from "@/modules/htsMedia";
import { OfferScreen } from "@/tracking/offers";
import { TRAVEL_DEALS_PATH } from "@/utilities";

/** Homepage "Travel offers" shelf; only on the hotels home. */
export const HotelDealsSection = ({ funnel }: { funnel: Funnel }) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "HotelDealsSection");

  const isLodging = funnel === Funnel.Lodging;
  const { deals, isLoading } = useTravelDeals(
    HtsMediaDealTilePlacement.Homescreen,
    { enabled: isLodging }
  );

  // Stay mounted while loading (skeletons hold the space); hide only when
  // not on the hotels home or loaded with nothing to show.
  if (!isLodging || (!isLoading && deals.length === 0)) {
    return null;
  }

  return (
    <section className={block}>
      <TravelDealsCarousel
        className={cn("content")}
        deals={deals}
        isLoading={isLoading}
        screen={OfferScreen.home}
        title={t("hotelDealsSection.title")}
        viewAll={{
          label: t("hotelDealsSection.shopAll"),
          to: TRAVEL_DEALS_PATH,
        }}
      />
    </section>
  );
};
